export default "__VITE_ASSET__NCI8nfcq__"